__turbopack_context__.v({
  "container": "yRO-hq_container",
  "figure": "yRO-hq_figure",
  "numberSign": "yRO-hq_numberSign",
  "rank": "yRO-hq_rank",
  "variant--top100": "yRO-hq_variant--top100",
});
